<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex"  vs-lg="3" vs-sm="4" vs-xs="12">
          <h3>Manage Opportunities View</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button size="small" type="flat" @click="saveViewPopup">Save View</vs-button>

<span class="mt-3 mr-5 ml-5">Select:</span>


  <v-select style="width:50%" v-model="selected_default_opportunities_view_for_client_user" label="name" :options="client_opp_view_options"
    name="sd_view" />
        </vs-col>


        <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="2"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-button
          @click="manageDefaultViewPopup"
          color="danger"
          type="border"
          >Manage View</vs-button
        >
        
      </vs-col>


      </vs-row>

      <DataGrid :context="'ManageClientDefaultOpportunities'" @goToEditSalesDeveloperOpportunities="goToEditSalesDeveloperOpportunities" ref="ClientDefaultOpportunities"
        :columnDefs="columnDefs" :rowData="records" :rowSelection="'single'" :dataSource="dataSource">
      </DataGrid>

      <vs-popup
      title="Default View Detail"
      :active.sync="showHideDefaultOpportuntiesViewDetailPopup"
    >
      <vs-row vs-w="12">
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Name:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                 {{ default_view_detail?default_view_detail.name:'' }}
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Description:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  {{ default_view_detail?default_view_detail.description:'' }}

                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-divider class="m-5" />


        <vs-col vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">




          <vs-row vs-w="12">
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
              <template v-for="cc in campaign_clients">


                <strong>  <u>Client : {{cc['company_name']}}</u> </strong>


                <div class="p-2"
                v-for="client_user in client_users"
                v-if="cc['uuid'] == client_user['client_id']"
                vs-type="flex"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >

               <template >




          
                <p class="p-1">{{ client_user.first_name }} {{ client_user.surname }}</p>

               </template>
               

              </div>

              <vs-divider class="m-5" />


              </template>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12">


               <strong><u>Elomark User: </u></strong> 


                <div
                class="p-1"
                v-for="elomark_user in elomark_users"
                vs-type="flex"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
              <template>

           
                <p class="p-1">{{ elomark_user.first_name }} {{ elomark_user.surname }}</p>

              </template>
              
            </div>



            </vs-col>
  
       
            
          </vs-row>






          
     
        </vs-col>
    
      </vs-row>
    </vs-popup>

    <vs-popup
    title="Edit Default View"
    fullscreen
    :active.sync="showHideEditDefaultOpportunitiesViewPopup"
  >


    <vs-row vs-w="12">
      <vs-col vs-lg="5" vs-sm="12" vs-xs="12">
        <vs-row>
          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/2 w-full">
                <h6>Name:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="default_view_edit_details.name"
                  name="name"
                />
                

               
              </div>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/2 w-full">
                <h6>Description:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-textarea
                  class="w-full"
                  name="save_view_description"
                  v-model="default_view_edit_details.description"
                />
                <vs-button
                  class="mt-5"
                  @click.prevent="updateDefaultViewAction"
                  >Submit</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-row>
          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/5 w-full"></div>

              <div class="vx-col sm:w-1/2 w-full">

                <template v-for="cc in campaign_clients">


                  <h5><u>Client : {{cc['company_name']}}</u></h5> 


                  <vs-col
                  class="p-2"
                  v-for="client_user in client_users"
                  v-if="cc['uuid'] == client_user['client_id']"
                  vs-type="flex"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                >

                 <template >




                  <input
                  @click="check($event)"
                    type="checkbox"
                    :value="client_user.uuid"
                    :checked="selected_users_for_edit.includes(client_user.uuid)?'checked':null"
                  />
                  <h6 class="p-1">{{ client_user.full_name }}</h6>

                 </template>
                 

                </vs-col>

                <vs-divider class="m-5" />


                </template>
              
                

                



             

                <!-- <v-select multiple name="save_view_user_id" label="full_name"
                :options="client_users"
                v-model="save_view_user_id" data-vv-as="Client User" /> -->
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12">
        <vs-row>
          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/5 w-full"></div>

              <div class="vx-col sm:w-1/2 w-full">
                <u> <h5 class="p-2">Elomark User:</h5> </u>

                <vs-col
                  class="p-1"
                  v-for="elomark_user in elomark_users"
                  vs-type="flex"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                >
                <template >

                  <input 
                  type="checkbox"
                  @click="check($event)"
                  :checked="selected_users_for_edit.includes(elomark_user.uuid)?'checked':null"
                  :value="elomark_user.uuid"
                />
                <h6 class="p-1">{{ elomark_user.full_name }}</h6>

                </template>
                
                </vs-col>

                <!-- <v-select multiple name="save_view_user_id" label="full_name"
              :options="client_users"
              v-model="save_view_user_id" data-vv-as="Client User" /> -->
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-popup>
      <vs-popup title="Opportunities" fullscreen :active.sync="showClientUserOpportunitiesPopUp">
        <vs-row>
          <div class="vx-col w-full p-2" v-for="field in opportunity_field_options">


            <!-- // Opportunities FIELD -->
            <div class="vx-row p-5" v-if="field.field_from == 'opportunity_field'
              ">
              <div class="vx-col sm:w-1/5 w-full">
                <h6>{{ field.name }}</h6>
              </div>
              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'text'">
                <vs-input class="w-full" v-model="opportunity_field_datas[field.formatted_key]
                  " name="name" />
              </div>

              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'number'
                ">
                <vs-input class="w-full" v-model="opportunity_field_datas[field.formatted_key]
                  " name="name" type="number" />
              </div>
              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'textarea'
                ">
                <vs-textarea v-model="opportunity_field_datas[field.formatted_key]
                  " />
              </div>
              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'date'
                ">

                <flat-pickr v-model="opportunity_field_datas[field.formatted_key]
                  " :config="configDateTimePicker" placeholder="Choose Date" name="continuous_date_end" />
              </div>

               <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'datetime'
                ">

                <flat-pickr v-model="opportunity_field_datas[field.formatted_key]
                  " :config="configDateAndTimePicker" placeholder="Choose Date And Time" name="continuous_date_and_time" />
              </div>

              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'checkbox'
                ">
                <span v-for="v in JSON.parse(field.values)" class="p-2">
                  <input type="checkbox" class="mr-2" :value="v.value"
                    v-model="opportunity_field_datas[field.formatted_key]" />


                  {{ v.value }}
                </span>
              </div>

              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'dropdown'
                ">
                <v-select v-model="opportunity_field_datas[field.formatted_key]
                  " label="value" :options="JSON.parse(field.values)" name="type" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>



              <div class="vx-col sm:w-1/3 w-full" v-if="field.type == 'choose_one'
                ">
                <span v-for="v in JSON.parse(field.values)" class="p-2">
                  <vs-radio :vs-name="field.field" :vs-value="v.value" class="mr-2" v-model="opportunity_field_datas[field.formatted_key]
                    ">{{ v.value }}</vs-radio>
                </span>
              </div>
            </div>


          </div>
          <div class="vx-row w-full p-5">
            <div class="vx-col sm:w-1/5 w-full">
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button class="ml-3" @click.prevent="updateOpportunity">Update</vs-button>
            </div>
          </div>
        </vs-row>
      </vs-popup>
     



      <vs-popup
      title="Save Default Opportunities View"
      fullscreen
      :active.sync="showHideSaveViewPopUp"
    >
      <vs-row vs-w="12">
        <vs-col vs-lg="5" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Name:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    v-validate="'required'"
                    class="w-full"
                    v-model="save_view_name"
                    name="name"
                  />

                   <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{
            errors.first("name") }}</span>
                  <!-- <span class="text-danger text-sm">{{
                    please_choose_save_view_name
                  }}</span> -->
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Description:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full"
                    name="save_view_description"
                    v-model="save_view_description"
                  />
                  <vs-button
                    class="mt-5"
                    @click.prevent="submitSaveViewAction"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/5 w-full"></div>

                <div class="vx-col sm:w-1/2 w-full">

                  <template v-for="cc in campaign_clients">


                    <h5><u>Client : {{cc['company_name']}}</u></h5> 


                    <vs-col
                    class="p-2"
                    v-for="client_user in client_users"
                    v-if="cc['uuid'] == client_user['client_id']"
                    vs-type="flex"
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                  >

                   <template >




                    <input
                      type="checkbox"
                      v-model="save_view_user_id"
                      :value="client_user.uuid"
                    />
                    <h6 class="p-1">{{ client_user.full_name }}</h6>

                   </template>
                   

                  </vs-col>

                  <vs-divider class="m-5" />


                  </template>
                
                  

                  



               

                  <!-- <v-select multiple name="save_view_user_id" label="full_name"
                  :options="client_users"
                  v-model="save_view_user_id" data-vv-as="Client User" /> -->
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/5 w-full"></div>

                <div class="vx-col sm:w-1/2 w-full">
                  <u> <h5 class="p-2">Elomark User:</h5> </u>

                  <vs-col
                    class="p-1"
                    v-for="elomark_user in elomark_users"
                    vs-type="flex"
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                  >
                  <template v-if="elomark_user.uuid != user_id">

                    <input 
                    type="checkbox"
                    v-model="save_view_user_id"
                    :value="elomark_user.uuid"
                  />
                  <h6 class="p-1">{{ elomark_user.full_name }}</h6>

                  </template>
                  
                  </vs-col>

                  <!-- <v-select multiple name="save_view_user_id" label="full_name"
                :options="client_users"
                v-model="save_view_user_id" data-vv-as="Client User" /> -->
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>

      <vs-popup
      title="Manage Opportunities View"
      fullscreen
      :active.sync="showHideManageDefaultViewPopup"
    >
    <DataGrid :context="'opportuntiesViewList'"
    :rowSelection="'single'"
    ref="opportuntiesViewList"
    :columnDefs="getDefaultViewColumns"
    :rowData="viewRecords"
    :dataSource="defaultOpportunitiesViewDataSource"
    @goToDefaultOpportunititesViewDetails="goToDefaultOpportunititesViewDetails"
    @goToEditDefaultOpportunititesView="goToEditDefaultOpportunititesView"

  >
  </DataGrid>
    </vs-popup>
    </vx-card>
  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  data: () => ({
    default_view_detail:{
      name : null,
      description: null,
      checked_user_ids : []
    },
    default_view_edit_details:{
      name : null,
      description: null,
      checked_user_ids : []
    },
    selected_default_view_users : [],
    selected_users_for_edit : [],
    showHideEditDefaultOpportunitiesViewPopup : false,
    showHideDefaultOpportuntiesViewDetailPopup : false,
    getDefaultViewColumns: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: 'CellRendererActions',
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 100
      },

      {
        headerName: "Name",
        flex:1,
        field: "name",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          suppressAndOrCondition: false
        }
      },
      {
        headerName: "Description",
        flex:1,
        field: "description",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          suppressAndOrCondition: false
        }
      }
    ],
    campaign_clients: [],
    save_view_user_id: [],
    client_users: [],
    elomark_users: [],
    campaignDetails: [],
    viewRecords: [],
    defaultOpportunitiesViewDataSource: {},
    showHideManageDefaultViewPopup: false,
    save_view_user_id: [],
    selected_default_opportunities_view_for_client_user: null,
    client_opp_view_options: [],
    showHideSaveViewPopUp: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    // checkedValues:['Ipad' , 'Laptop' ],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
    showClientUserOpportunitiesPopUp: false,
    closeshowClientUserOpportunitiesPopUp: false,
    opportunity_field_options: [],
    opportunity_field_datas: [],
    abilities: null,
    columnDefs: [
    ],
    dataSource: {},
    records: []
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignManagement,
    DataGrid,
    flatPickr,

  },
  watch: {
    selected_default_opportunities_view_for_client_user (val) {
      const opportunities_saved_state = JSON.parse(val.opportunities_view)
      this.$refs.ClientDefaultOpportunities.gridApi.applyColumnState({
        state: opportunities_saved_state,
        applyOrder: true
      })



      const opportunities_filter_saved_state = JSON.parse(val.opportunities_filter)
      this.$refs.ClientDefaultOpportunities.gridApi.setFilterModel(
        opportunities_filter_saved_state
      )

    }
  },
  methods: {
    updateDefaultViewAction () {
      let self = this

    
          self.default_view_edit_details.checked_user_ids = self.selected_users_for_edit

        self.$store
          .dispatch(
            'campaignsManagement/updateDefaultOpportuntiesViewAction',
            self.default_view_edit_details
          )
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                location.reload();

              }
            }
          })
          .catch(err => {
            console.log(err)
          })



    },
    check(e){
      let self = this
      if(e.target.checked){
        self.selected_users_for_edit.push(e.target.value)
      }else{
        self.selected_users_for_edit = self.selected_users_for_edit.filter(function(item) {
            return item !== e.target.value
        })
      }



      self.selected_users_for_edit = self.selected_users_for_edit.filter((item, i, ar) => ar.indexOf(item) === i);


    },
    getDefaultOpportunitiesViewSelectedUsersForUpdate (id) {
      let self = this
      let data = {}
      data.view_id = id
      self.$store
        .dispatch('campaignsManagement/getDefaultOpportunitiesViewSelectedUsers', data)
        .then(res => {
          if (res) {


            let response_data = res.data

            if(response_data){
              self.selected_default_view_users = JSON.parse(response_data)


              self.selected_default_view_users.forEach(function(ele){
                self.selected_users_for_edit.push(ele.uuid)
              })

              





            }
            


            console.log("SELECTED Users" , self.selected_users_for_edit)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDefaultOpportunitiesViewSelectedUsers (id) {
      let self = this
      let data = {}
      data.view_id = id
      self.$store
        .dispatch('campaignsManagement/getDefaultOpportunitiesViewSelectedUsers', data)
        .then(res => {
          if (res) {


            self.client_users = []
            self.elomark_users = []

            let response_data = res.data

            if(response_data){
              self.selected_default_view_users = JSON.parse(response_data)


              self.selected_default_view_users.forEach(function (e) {


              if (e.is_client == 'y') {
                self.client_users.push(e)
              } else {
                self.elomark_users.push(e)
              }




              })


              self.client_users = Object.values(self.client_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));


              self.elomark_users = Object.values(self.elomark_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));


            }


            console.log("Users" , self.client_users)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    goToDefaultOpportunititesViewDetails(data){
      
      this.default_view_detail = data

      this.getDefaultOpportunitiesViewSelectedUsers(data.uuid)
      this.showHideDefaultOpportuntiesViewDetailPopup = true

      // console.log("sdfsdfsdf" , data)
      //  alert("poeeoeo")
    },
    goToEditDefaultOpportunititesView(data){
      this.selected_users_for_edit = []
      this.default_view_edit_details = {
      name : null,
      description: null,
      checked_user_ids : []
    }
      this.default_view_edit_details = data
      this.fetchCampaignUsers()
      this.getDefaultOpportunitiesViewSelectedUsersForUpdate(data.uuid)
      this.showHideEditDefaultOpportunitiesViewPopup = true

      // console.log("sdfsdfsdf" , data)
      //  alert("poeeoeo")
    },
    getCampaignClients() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          self.$route.params.campaignId
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);

            console.log("Campaign client" ,  self.campaign_clients)

           

      

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchCampaignUsers () {
      let self = this
      const campaignId = self.$route.params.campaignId
      self.client_users = []
      self.elomark_users = []

      self.$store
        .dispatch('campaignsManagement/fetchCampaignUsers', campaignId)
        .then(res => {
          let response_data = res.data
          if (response_data) {
            response_data = JSON.parse(res.data)
          }

          response_data.forEach(function (e) {


            if (e.is_client == 'y') {
              self.client_users.push(e)
            } else {
              self.elomark_users.push(e)
            }




          })

          
          self.client_users = Object.values(self.client_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));


          self.elomark_users = Object.values(self.elomark_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));

          // let unique = [...new Set(self.elomark_users.map(item => item.uuid))];


          


             


        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getdefaultOpportunitiesViewDataSource() {
      var self = this;
      this.defaultOpportunitiesViewDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.$route.params.campaignId;
          self.$store
            .dispatch(
              "campaignsManagement/getdefaultOpportunitiesViewDataSource",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.opportuntiesViewList.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow });
              } else {
                self.$refs.opportuntiesViewList.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    manageDefaultViewPopup () {
      this.showHideManageDefaultViewPopup = true
    },
    submitSaveViewAction() {
      let self = this
      let data = {}
      data.name = self.save_view_name
      data.description = self.save_view_description
      data.campaign_id = self.$route.params.campaignId;
      self.save_view_user_id.push(self.user_id)

      self.save_view_user_id = self.save_view_user_id.filter(function (
        item,
        pos
      ) {
        return self.save_view_user_id.indexOf(item) == pos
      })

      data.save_view_user_id = self.save_view_user_id
      data.is_default_view = true

      data.opportunities_view =
        this.$refs.ClientDefaultOpportunities.gridApi.getColumnState()
      data.opportunities_filter =
        this.$refs.ClientDefaultOpportunities.gridApi.getFilterModel()
      if (self.save_view_name != null) {
        self.$store
          .dispatch("campaignsManagement/saveOpportunitiesSavedView", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.ClientDefaultOpportunities.gridApi.refreshServerSide({purge : true});
                self.getDataSource();
                self.showHideSaveViewPopUp = false;
                self.selected_status = null;
                self.getOpportunitiesSavedViewLists()
                self.$refs.opportuntiesViewList.gridApi.refreshServerSide({purge : true});


              

              }else{
                self.$vs.notify({
                    color: "danger",
                    title: "Save Opportunity View",
                    text: res.data.message
                  });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }


    },
    saveViewPopup() {
      this.save_view_name = null
      this.save_view_description = null
      this.save_view_user_id = []
    //   this.selected_users_for_edit = []
    //   this.default_view_edit_details = {
    //   name : null,
    //   description: null,
    //   checked_user_ids : []
    // }


      
      this.showHideSaveViewPopUp = true
      // console.log("Account COLUMNSTATE" , this.$refs.SDQCAccount.gridApi.getColumnState())

      // console.log("Contact COLUMNSTATE" , this.$refs.SDQCContact.gridApi.getColumnState())


    },
    getOpportunitiesSavedViewLists() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getClientOpportunitiesSavedViewLists", data)
        .then(res => {
          if (res) {
            self.client_opp_view_options = JSON.parse(res.data);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateOpportunity() {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/updateSDCreatedOpportunity", self.opportunity_field_datas)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Opportunity",
              text: res.data.message
            });
            this.$router.go(0)
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSelectedOpportunityFieldsWithDetails() {
      let self = this;
      let data = {}
      data.id = this.$route.params.campaignId;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedOpportunityFieldsWithDetails",
          data
        )
        .then(response => {
          let result = JSON.parse(response.data);
          self.opportunity_field_options = result



          self.opportunity_field_options.forEach(function (ele) {
            if (ele.type == 'checkbox') {

              for (var key in self.opportunity_field_datas) {

                if (key == ele.formatted_key) {


                  if (self.opportunity_field_datas[key]) {
                    self.opportunity_field_datas[key] = self.opportunity_field_datas[key].split(",")

                  } else {
                    self.opportunity_field_datas[key] = []
                  }


                }
              }
            }
          })


          // console.log("FIELDS", self.opportunity_field_options)
          // console.log("datas", self.opportunity_field_datas)

        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSDOpportunitiesColumns() {
      let self = this
      this.$store
        .dispatch(
          "campaignsManagement/getSDOpportunitiesColumns",
          self.$route.params.campaignId
        )
        .then(response => {

          let result = JSON.parse(response.data);


          console.log("Opp Columns", result)


          result.forEach(function (ele) {
              ele.headerName = ele.name
              ele.field = ele.column_id
                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.flex = 1
              ele.filterParams = {
                buttons: ['apply', 'reset'],
                maxNumConditions: 4
              }
            })

            this.columnDefs = result;


          let account_name = {
            headerName: 'account',
            flex: 1,
            field: 'company_name',
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            }
          };

          let contact_name = {
            headerName: 'contact',
            flex: 1,
            field: 'contact_full_name',
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            }
          };

 
          this.columnDefs.push(account_name);

          this.columnDefs.push(contact_name);


          let actions = {
            headerName: "Actions",
            sortable: false,
        field: "transactions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 50
          };

 
          this.columnDefs.push(actions);



         







        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            self.$router.replace("/login");
          }
        });
    },
    goToEditSalesDeveloperOpportunities(value) {
      console.log(value)
      var self = this;
      self.getSelectedOpportunityFieldsWithDetails()
      self.opportunity_field_datas = value



      self.showClientUserOpportunitiesPopUp = true;
      // this.showPopulateDataPopUp = true;
      // alert(value)
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          params.request.sales_developer_id = self.user_id;
          params.request.selected_campaign_id = self.$route.params.campaignId
          self.$store
            .dispatch(
              "campaignsManagement/getClientOpportunities",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;


              console.log("RESPONSE DATA", response_data)



            

              if (response_data.length != 0) {
                self.$refs.ClientDefaultOpportunities.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.ClientDefaultOpportunities.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getdefaultOpportunitiesViewDataSource()
    this.fetchCampaignDetails()
    // this.getDataSource();
  },
  mounted() {
    this.getDataSource();
    this.getSDOpportunitiesColumns();
    this.getOpportunitiesSavedViewLists();

    this.getCampaignClients()
    this.fetchCampaignUsers()

  },
  created() {

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];


    // if (this.user_role != 'Client' && this.user_role != 'Client Administrator') {
    //   this.$router.replace("/unauthorized")
    // }

    if (this.user_role == 'Sales Developer'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }

    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Tags
  .con-btns-Tags
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Tagsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
